import { restApi } from '../../services/api';

export type InstagramConfig = {
  token: string;
  id: string;
};

export const instagramRepository = () => ({
  validateCodeBrand: (code: string) => restApi.post(`/general-settings/brand/instagram`, { code }),
  validateCodeStore: (code: string) => restApi.post(`/general-settings/store/instagram`, { code }),
  getInstagramBrand: (brandId: string) =>
    restApi.get<InstagramConfig>(`/showroom/${brandId}/instagram`),
  getInstagramStore: (storeId: string) =>
    restApi.get<InstagramConfig>(`/storefront/${storeId}/instagram`),
  removeConfigBrand: () => restApi.delete(`/general-settings/brand/instagram`),
  removeConfigStore: () => restApi.delete(`/general-settings/store/instagram`),
});
